import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './Auth.css';

function Login({ onToggleMode, onSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { signIn, refreshProfile, userProfile } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    if (!email || !password) {
      setError('Please fill in all fields');
      setIsLoading(false);
      return;
    }

    try {
      const { data, error } = await signIn(email, password);

      if (error) {
        setError(error.message || 'Invalid email or password');
        setIsLoading(false);
      } else {
        // Login successful
        console.log('Login successful, session:', data?.session ? 'active' : 'pending');
        
        if (data?.session) {
          // Wait for auth state to propagate
          await new Promise(resolve => setTimeout(resolve, 300));
          
          // Refresh profile to ensure nickname is loaded
          if (refreshProfile) {
            await refreshProfile();
          }
          
          // Wait a bit for profile to load and state to update
          await new Promise(resolve => setTimeout(resolve, 500));
          
          // Close modal - App component will also close it via useEffect as backup
          if (onSuccess) onSuccess();
          setIsLoading(false);
        } else {
          // Session might be pending (email confirmation)
          setIsLoading(false);
        }
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('An unexpected error occurred. Please try again.');
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2 className="auth-title">Login</h2>
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="auth-input-group">
            <input
              type="email"
              className="auth-input"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isLoading}
              required
            />
          </div>
          <div className="auth-input-group">
            <input
              type="password"
              className="auth-input"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={isLoading}
              required
            />
          </div>
          {error && <div className="auth-error">{error}</div>}
          <button
            type="submit"
            className="auth-submit-btn"
            disabled={isLoading}
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        <div className="auth-footer">
          <span>Don't have an account? </span>
          <button className="auth-link-btn" onClick={onToggleMode}>
            Sign up
          </button>
        </div>
      </div>
    </div>
  );
}

export default Login;

